import { render, staticRenderFns } from "./RequestAutoAssignBrigades.vue?vue&type=template&id=28aab333&scoped=true&"
import script from "./RequestAutoAssignBrigades.vue?vue&type=script&lang=js&"
export * from "./RequestAutoAssignBrigades.vue?vue&type=script&lang=js&"
import style0 from "./RequestAutoAssignBrigades.vue?vue&type=style&index=0&id=28aab333&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28aab333",
  null
  
)

export default component.exports
import {QSeparator,QTr,QTh,QTd,QItem,QItemSection,QItemLabel,QIcon,QTooltip,QInnerLoading,QSpinnerGears} from 'quasar'
component.options.components = Object.assign({QSeparator,QTr,QTh,QTd,QItem,QItemSection,QItemLabel,QIcon,QTooltip,QInnerLoading,QSpinnerGears}, component.options.components || {})
